
import includes from 'lodash/includes';

import {
    EDIT_KATUZE_ACTION_TYPE,
    GET_PROJECT_ACTION_TYPE
} from '../sagas/project';
import {
    GET_OPSUB_ACTION_TYPE
} from '../sagas/opsub';
import {
    GET_ANALYZE_ACTION_TYPE,
    SET_SELECTED_TEL_ACTION_TYPE,
    SET_DIRECTION,
    SET_ISKN_DATE,
    SET_ISKN_DATE_CHECKED,
    SET_OPSUB_ITEM
} from '../sagas/analyze';

import { getOpsubAddress, getOpsubName, getOpsubRcIco } from './opsub';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    analyzeData: null,
    selectedTel: [],
    direction: 'forward',
    isknDateChecked: [],
    isknDate: null,
    opsubItem: null
};

export function getDirection(state) {
    return state.direction;
}

export function getIsknDateChecked(state) {
    return state.isknDateChecked;
}

export function getIsknDate(state) {
    return state.isknDate;
}

export function getOpsubItem(state) {
    return state.opsubItem;
}

export function getAnalyzeData(state) {
    return state.analyzeData;
}

export function getAnalyzeResultBySelectedTel(analyzeResult, selectedTel) {

    const selectedTelId = selectedTel
        .filter(item => item.selected)
        .map(item => item.tel_id);

    const tel = analyzeResult.tel.filter(item => includes(selectedTelId, item.tel_id));
    const par = analyzeResult.par.filter(item => includes(selectedTelId, item.tel_id));
    const vla = analyzeResult.vla.filter(item => includes(selectedTelId, item.tel_id));

    const opsubId = vla.map(item => item.opsub_id);

    const opsub = analyzeResult.opsub.filter(item => includes(opsubId, item.opsub_id));

    return {
        ...analyzeResult,
        opsub: [...opsub],
        par: [...par],
        tel: [...tel],
        vla: [...vla]
    }
}

export function getOpsubForOpsub(analyzeResult, opsubId) {
    return analyzeResult.opsub.filter(item => {
        return (item.opsub_id === opsubId);
    }).map(item => {
        return {
            ...item,
            _address: getOpsubAddress(item),
            _name: getOpsubName(item),
            _rcico: getOpsubRcIco(item),
        }
    });
}

export function getParForOpsub(analyzeResult, opsubId) {
    const tel = getTelForOpsub(analyzeResult, opsubId);
    return analyzeResult.par.filter(item => {
        return (tel.indexOf(item.tel_id) !== -1);
    });
}

export function getTelForOpsub(analyzeResult, opsubId) {
    return analyzeResult.vla.filter(item => {
        return (item.opsub_id === opsubId);
    }).map(item => {
        return item.tel_id;
    });
}

export function getSelectedTel(state) {
    return state.selectedTel;
}

function compare(a, b) {
    if (a < b) {
        return -1;
    } else {
        if (a > b) {
            return 1;
        } else {
            return 0;
        }
    }
}

function getTelFromAnalyzeData(analyzeData) {
    let telItems = [];

    const existsTel = (tel) => {
        return telItems.reduce((previous, current) => {
            return (current.tel_id === tel.tel_id)
                ? true
                : previous;
        }, false);
    }

    analyzeData.output.data.forEach(analyzeResult => {
        analyzeResult.tel.forEach(tel => {
            if (!existsTel(tel)) {
                telItems.push(tel);
            }
        })
    });

    telItems.sort((a, b) => {
        let res = compare(a.katuze_nazev, b.katuze_nazev);
        if (res === 0) {
            res = compare(parseInt(a.cislo_tel), parseInt(b.cislo_tel));
        }
        return res;
    });

    return telItems;
}

function processActionResult(state, action) {
    switch (action.data.result.operation) {
        case GET_ANALYZE_ACTION_TYPE.DEFAULT:
            return {
                analyzeData: action.data.result.result,
                selectedTel: getTelFromAnalyzeData(action.data.result.result).map(item => {
                    return {
                        ...item,
                        selected: true
                    }
                })
            };
        default:
            return {};
    }
}

function setSelectedTel(state, action) {

    let selectedTel = [...state.selectedTel];
    selectedTel.forEach(item => {
        if(item.tel_id === action.telId) {
            item.selected = action.selected;
        }
    })

    return {
        ...state,
        selectedTel: selectedTel
    };
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(GET_ANALYZE_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case GET_PROJECT_ACTION_TYPE.SUCCESS:
                return {
                    ...initialState
                };

            case EDIT_KATUZE_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_OPSUB_ACTION_TYPE.DEFAULT:
                return {
                    ...state,
                    ...loaderInitialState,
                };

            case GET_ANALYZE_ACTION_TYPE.SUCCESS:
                return {
                    ...state,
                    ...loaderReducer(state, action),
                    ...processActionResult(state, action)
                };

            case SET_DIRECTION:
                return {
                    ...state,
                    direction: action.direction,
                    isknDateChecked: []
                };

            case SET_ISKN_DATE:
                return {
                    ...state,
                    isknDate: action.isknDate,
                    isknDateChecked: []
                };

            case SET_ISKN_DATE_CHECKED:
                return {
                    ...state,
                    isknDateChecked: action.isknDateChecked
                };

            case SET_OPSUB_ITEM:
                return {
                    ...state,
                    opsubItem: action.opsubItem
                };

            case SET_SELECTED_TEL_ACTION_TYPE:
                return setSelectedTel(state, action);

            default:
                return loaderReducer(state, action);
        }
    };
}
